import lodash from 'lodash'
import atendimentoSequoiaService from '../services/atendimentoSequoia.service'

const {
	getAtendimentosFundacao,
	updateAtendimentoSequoia,
	createAtendimentoSequoia: createAtendimentoRapidoService,
} = atendimentoSequoiaService()

export default {
	data() {
		return {
			isLoadingAtendimentoRapido: false,
			fundacaoIdSelecionado: null,
		}
	},

	methods: {
		addClienteAtendimentoRapido(clienteId) {
			this.fundacaoIdSelecionado = clienteId
		},

		removeClienteAtendimentoRapido(clienteId) {
			this.fundacaoIdSelecionado = null
		},

		clearClienteAtendimentoRapido() {
			this.fundacaoIdSelecionado = null
		},

		async createAtendimentoRapido(
			tipoAtendimentoRapido,
			menssagemAtendimentoRapido,
			tituloAtendimento = null,
			dataAtendimento = null
		) {
			try {
				this.isLoadingAtendimentoRapido = true

				/* 				const { atendimentos } = await getAtendimentosFundacao(
					this.listaClientesAtendimentoRapido
				) */

				const formDataAtendimentoRapido = {
					fundacao: Number(this.fundacaoIdSelecionado),
					titulo_atendimento: tituloAtendimento,
					tipo: '0',
					data_atendimento: dataAtendimento ?? new Date().toISOString(),
					descricao_atendimento: menssagemAtendimentoRapido,
					concluido: true,
					modalidade_fundacao: '0',
				}

				const responseAtividadeRapida = await createAtendimentoRapidoService(
					formDataAtendimentoRapido
				)

				this.clearClienteAtendimentoRapido()

				return responseAtividadeRapida
			} catch (e) {
				console.log(e)
			} finally {
				this.isLoadingAtendimentoRapido = false
			}
		},

		async updateAtendimentoRapido(
			menssagemAtendimentoRapido,
			tituloAtendimento = null,
			dataAtendimento = null,
			idAtendimento = null
		) {
			try {
				this.isLoadingAtendimentoRapido = true

				/* 				const { atendimentos } = await getAtendimentosFundacao(
					this.listaClientesAtendimentoRapido
				) */

				const formDataAtendimentoRapido = {
					titulo_atendimento: tituloAtendimento,
					data_atendimento: dataAtendimento ?? new Date().toISOString(),
					descricao_atendimento: menssagemAtendimentoRapido,
				}
				const responseAtividadeRapida = await updateAtendimentoSequoia(
					formDataAtendimentoRapido,
					idAtendimento
				)

				this.clearClienteAtendimentoRapido()

				return responseAtividadeRapida
			} catch (e) {
				console.log(e)
			} finally {
				this.isLoadingAtendimentoRapido = false
			}
		},

		async getAtendimentosSequoiaById() {
			try {
				this.isLoadingAtendimentoRapido = true

				const responseAtendimentosSequoia = await getAtendimentosFundacao(
					this.fundacaoIdSelecionado
				)

				if (lodash.isEmpty(responseAtendimentosSequoia)) {
					return []
				}

				return responseAtendimentosSequoia
			} catch (e) {
				console.log(e)
			} finally {
				this.isLoadingAtendimentoRapido = false
			}
		},
	},
}
